import React from 'react';
import hero from '../../images/hero.jpg';
import Footer from '../Shared/Footer/Footer';
import Navigation from '../Shared/Navigation/Navigation';
import './About.css'

const About = () => {
    return (
        <>
            <Navigation />
            <main id="about" className='container mt-5'>
                <div className="about-info">
                    <div className='row mb-5'>
                        <div className='col-md-4  d-flex justify-content-center' data-aos='fade-right' data-aos-duration="500">
                            <img src={hero} alt="John Doe" className="bio-image " />
                        </div>
                        <div className='col-md-8' data-aos='fade-left' data-aos-duration="1000">
                            <h2 className="lg-heading text-white">About Me</h2>
                            <h2 className="sm-heading text-white">Let me introduce...</h2>
                            <p className='bio mt-5 summery'>
                                I am a quick learner. I believe in hard work
                                and efficiency. I always like to learn new
                                things and have experience with new stuff.
                                Dedicated, energetic, and motivated team
                                player seeking a career that would enable me
                                to utilize into the Web developing field.
                            </p>
                        </div>
                    </div>

                    <div className='row p-5'>
                        <div className="col-md-6 aboutt" style={{ minHeight: '220px', height: '300px' }} data-aos="flip-left">
                            <div class="card " >
                                <div class="card-body">
                                    <h5 style={{ color: 'black' }} class="card-title">Skills</h5>
                                    <p style={{ color: 'black' }} class="card-text">
                                        • <strong>Experts :</strong>JavaScript, ES6, React.js, React-Bootstrap, CSS3, HTML5, Bootstrap, Material-UI, REST API, <br />
                                        • <strong>Comfortable : </strong> Redux.js, Node.js, Express.js, MongoDB, Rest API, React       Native, Firebase, base64 <br />
                                        • <strong>Familiar :</strong> SASS, SCSS, TypeScript<br />
                                        • <strong>Tools :</strong> Git, VSCode, Chrome Dev Tool<br />
                                        • <strong>OS :</strong> Windows, Mac
                                    </p>
                                </div>
                            </div>

                        </div>

                        <div className="col-md-6 aboutt" data-aos="flip-right">
                            <div class="card  " style={{ minHeight: '220px', height: '250px' }} >
                                <div class="card-body">
                                    <h5 style={{ color: 'black' }} class="card-title">Personal Info</h5>
                                    <p style={{ color: 'black' }} class="card-text">
                                        <strong>Name</strong>          :   Shahinur Alam Bhuiyan<br />
                                        <strong>DoB</strong>           :   19th Sep 2001 <br />
                                        <strong>Nationality</strong>   :   Bangladeshi <br />
                                        <strong>Blood Group</strong>   :  A+<br />
                                        <strong>Religion</strong>      :   Muslim <br />
                                    </p>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div className="cv mb-4" data-aos='fade-right'>
                    <a href="https://drive.google.com/uc?export=download&amp;id=1R98QtDc2Ugrpi1adkBoSc13PGRqNccO1" className="btn btn-outline-info">Download Resume&nbsp;<i class="fa fa-arrow-down"></i></a>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default About;